// 积分条目类型
export enum PointsType {
  trade = 1, // trade to eran
  dex100 = 2,
  createWallet = 3,
  wsot = 4,
  invite = 5,
  checkIn = 6,
  socialmedia = 7,
  tgPoints = 8,
}
//可claim状态 0不可领取，1可以领取，2已领取
export enum ClaimStatus {
  no = 0,
  yes = 1,
  done = 2,
}

export interface WalletBase {
  walletId: string;
  walletType: number;
}

export interface BaseRes<T> {
  code: number;
  success: boolean;
  message: string;
  result: T;
}

export interface ShortLinkRes {
  code: number;
  message: string;
  tinyUrl: string;
  originalUrl: string;
}

export interface WalletConfigRes {
  dexProAmount?: number;
  wsotScale?: number;
  endTime?: number;
  capital?: number;
}

export interface WalletStatRes {
  totalPoint?: string;
  totalWalletId?: string;
}

export interface WalletTotalPointRes {
  point?: string | number; // 总已领取积分
  rankRate?: string | number; // 排名百分比
  inviteNum?: number; //有效邀请人数
  invitePoint?: number; //有效邀请获取积分数
  tradePoint?: number; // Trade 已领取积分
}

export interface WalletTypePointRes {
  point: string | number; //已领取积分
  unClaimPoint: string | number; //未领取积分
  wsotPoint: number; //wsot积分
  status: number; // 0不可领取，1可以领取，2已领取
  type: number; // 1 tradeToEarn 2dexpro100 3 import 4 wsot 5 invite 7 关注社媒
}

export interface WalletPointLog {
  type: string | number;
  claimPoint: string | number;
  createdAt: number;
}

export interface CheckinHistoryItem {
  date?: string;
  point?: number;
  hasCheckin?: boolean;
  today?: boolean;
}

export interface TradeHistoryItem {
  point: number;
  time: number | string;
  amount: number | string;
  id: number;
}
